export const appCdnURL = "https://asset.legendtrading.com/_service/www/"

export const appHead = {"meta":[{"charset":"utf-8"},{"property":"og:image","content":"https://www.legendtrading.com/favicon-32x32.png"},{"hid":"description","name":"description","content":"Legend Trading is a leading U.S. regulated crypto trading firm trusted by 900+ institutional clients, with $10billion+ trading volume per year. Its over-the-counter (OTC) trading service offers deep liquidity and customizable services that are suited for brokerage firms, investment advisors, family offices, corporations, and high net-worth individuals. Legend Trading also offers a comprehensive fiat-to-crypto gateway for banks, crypto exchanges, wallets, and NFT platforms to integrate and enable their customers to buy/sell crypto with bank transfer and credit/debit cards."},{"hid":"keywords","name":"keywords","content":"Cryptocurrency OTC, Bitcoin OTC, fiat OTC, on-ramp, off-ramp, USDT, Tether, USDC, PAX, TUSD, Silvergate Bank, International wire transfer, post trade settlement, Asia"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5, minimal-ui, shrink-to-fit=no"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/img/icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/img/icons/favicon-16x16.png"},{"rel":"stylesheet","href":"https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/css/flag-icons.min.css"}],"style":[],"script":[{"children":"window.zESettings = {\n          webWidget: {\n            position: { horizontal: 'right', vertical: 'bottom' },\n            contactForm: {\n              ticketForms: [{ id: 1260815247409 }],\n              attachments: false\n            }\n          }\n        };"},{"id":"ze-snippet","type":"text/plain","src":"https://static.zdassets.com/ekr/snippet.js?key=965a118c-4fcb-4510-b492-14b361fc6799","data-cookieconsent":"statistics","onload":"if(window.zE){window.zE('webWidget', 'hide');}"},{"id":"wow","src":"https://wowjs.uk/dist/wow.min.js","async":true,"onload":"var wow = new window.WOW({\n            animateClass: 'animated',\n          });\n          wow.init()"}],"noscript":[],"title":"Legend Trading"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000